import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateTime, Interval } from 'luxon';
import { LocalDateTimeRangeDTO } from 'src/app/services/api/api';
import { SbLocalDateTime } from 'src/app/services/api/api-date-time';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'sb-calendar-day',
  templateUrl: './sb-calendar-day.component.html',
  styleUrls: ['./sb-calendar-day.component.scss'],
  standalone: false,
})
export class SbCalendarDayComponent implements OnInit {
  // tslint:disable-next-line:variable-name
  _currentDay: SbLocalDateTime;
  @Input()
  set currentDay(value: SbLocalDateTime) {
    if (value) {
      this._currentDay = value;
    } else {
      this._currentDay = new SbLocalDateTime(DateTime.local());
    }

    this.render();
  }

  get currentDay(): SbLocalDateTime {
    return this._currentDay;
  }

  @Output() changeCurrentDay: EventEmitter<SbLocalDateTime>;

  // tslint:disable-next-line:variable-name
  _dateTimeRanges: LocalDateTimeRangeDTO[];
  @Input()
  set dateTimeRanges(value: LocalDateTimeRangeDTO[]) {
    if (value) {
      this._dateTimeRanges = value;
    } else {
      this._dateTimeRanges = [];
    }

    this.render();
  }

  get dateTimeRanges(): LocalDateTimeRangeDTO[] {
    return this._dateTimeRanges;
  }

  hours: any[] = [];

  constructor(public util: UtilService) {
    this.changeCurrentDay = new EventEmitter<SbLocalDateTime>();
  }

  ngOnInit() {
    this.render();
  }

  init() {
    this.hours = [];

    for (let d = 0; d < 24; d++) {
      this.hours.push({ hour: d, marked: false, partial: false });
    }

    if (!this.currentDay) {
      this._currentDay = new SbLocalDateTime(DateTime.local());
    }

    if (!this.dateTimeRanges) {
      this.dateTimeRanges = [];
    }
  }

  render() {
    this.init();
    for (const hour of this.hours) {
      const tempMo: SbLocalDateTime = new SbLocalDateTime(this.currentDay.value.set({ hour: hour.hour }).startOf('hour'));
      const isMarked: boolean = this.checkMarked(tempMo);
      const isPartial: boolean = isMarked ? false : this.checkPartial(tempMo);
      hour.marked = isMarked;
      hour.partial = isPartial;
    }

    const tempHours = this.hours;

    this.hours = [];

    this.hours = tempHours.slice(0);
  }

  checkMarked(tempMo: SbLocalDateTime) {
    if (!this._dateTimeRanges || this._dateTimeRanges.length === 0) {
      return false;
    } else {
      const startOfHour = tempMo.value.startOf('hour');
      const endOfHour = tempMo.value.endOf('hour');

      for (const range of this._dateTimeRanges) {
        const moFrom: SbLocalDateTime = new SbLocalDateTime(range.from.value);
        const moTill: SbLocalDateTime = new SbLocalDateTime(range.till.value);

        if (!moTill.encodeMillis) {
          // add milliseconds to day
          moTill.value = moTill.value.set({ millisecond: 999 });
        }

        const startOfHourMatches: boolean = startOfHour >= moFrom.value;
        const endOfHourMatches: boolean = endOfHour <= moTill.value;
        const startOfHourBetween: boolean = Interval.fromDateTimes(moFrom.value, moTill.value).contains(startOfHour);
        const endOfHourBetween: boolean = Interval.fromDateTimes(moFrom.value, moTill.value).contains(endOfHour);

        if ((startOfHourMatches || startOfHourBetween) && (endOfHourMatches || endOfHourBetween)) {
          return true;
        }
      }
    }
    return false;
  }

  checkPartial(tempMo: SbLocalDateTime) {
    if (!this._dateTimeRanges || this._dateTimeRanges.length === 0) {
      return false;
    } else {
      for (const range of this._dateTimeRanges) {
        const moFrom = range.from.value.startOf('hour');
        const moTill = range.till.value.endOf('hour');

        if (tempMo.value === moFrom || tempMo.value === moTill || Interval.fromDateTimes(moFrom, moTill).contains(tempMo.value)) {
          return true;
        }
      }
    }
    return false;
  }

  getClasses(hour) {
    let clazz: string = '';
    if (hour.partial) {
      clazz += ' partial';
    } else if (hour.marked) {
      clazz += ' marked';
    }
    return clazz;
  }

  formatHour(hour: any) {
    const format: string = (hour.hour < 10 ? '0' : '') + hour.hour;

    return format + ':00';
  }

  incDay() {
    this.currentDay = new SbLocalDateTime(this.currentDay.value.plus({ days: 1 }));
    this.changeCurrentDay.emit(this.currentDay);
  }

  decDay() {
    this.currentDay = new SbLocalDateTime(this.currentDay.value.minus({ days: 1 }));
    this.changeCurrentDay.emit(this.currentDay);
  }
}
